import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

import { mq } from '@/ui-kit/theme';

const StyledActions = styled.div(() => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',

    [mq.xs]: {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
    },
  };
});

interface IActionsProps extends PropsWithChildren {
  className?: string;
}

export const Actions = ({
  className,
  children,
}: IActionsProps) => {
  return (
    <StyledActions className={className}>
      {children}
    </StyledActions>
  );
};
